/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddressCreate,
    AddressCreateFromJSON,
    AddressCreateToJSON,
    AddressUpdate,
    AddressUpdateFromJSON,
    AddressUpdateToJSON,
    Contact,
    ContactFromJSON,
    ContactToJSON,
    ContactUpdate,
    ContactUpdateFromJSON,
    ContactUpdateToJSON,
    CreateRelatedDeal,
    CreateRelatedDealFromJSON,
    CreateRelatedDealToJSON,
    Distraint,
    DistraintFromJSON,
    DistraintToJSON,
    Lead,
    LeadFromJSON,
    LeadToJSON,
    NotFound,
    NotFoundFromJSON,
    NotFoundToJSON,
    PaginatedPersonList,
    PaginatedPersonListFromJSON,
    PaginatedPersonListToJSON,
    PaginatedRelatedDealsList,
    PaginatedRelatedDealsListFromJSON,
    PaginatedRelatedDealsListToJSON,
    PaginatedScreeningListItemList,
    PaginatedScreeningListItemListFromJSON,
    PaginatedScreeningListItemListToJSON,
    PatchedContactUpdate,
    PatchedContactUpdateFromJSON,
    PatchedContactUpdateToJSON,
    PatchedDistraint,
    PatchedDistraintFromJSON,
    PatchedDistraintToJSON,
    PatchedPerson,
    PatchedPersonFromJSON,
    PatchedPersonToJSON,
    Person,
    PersonFromJSON,
    PersonToJSON,
    RealtyRight,
    RealtyRightFromJSON,
    RealtyRightToJSON,
    RelatedDeal,
    RelatedDealFromJSON,
    RelatedDealToJSON,
    Screening,
    ScreeningFromJSON,
    ScreeningToJSON,
    ZobiScreeningData,
    ZobiScreeningDataFromJSON,
    ZobiScreeningDataToJSON,
} from '../models';

export interface CreateAddressRequest {
    personId: string;
    addressCreate: AddressCreate;
}

export interface CreateContactRequest {
    personId: string;
    contact: Contact;
}

export interface CreateLeadRequest {
    id: number;
}

export interface CreatePersonRequest {
    person?: Person;
}

export interface CreateRelatedDealRequest {
    personId: string;
    createRelatedDeal: CreateRelatedDeal;
}

export interface DownloadDistraintRequest {
    personId: string;
}

export interface DownloadRealtyRightsRequest {
    personId: string;
}

export interface DownloadScreeningRequest {
    id: number;
    personId: string;
}

export interface GetPersonRequest {
    id: number;
}

export interface GetScreeningRequest {
    id: number;
    personId: string;
}

export interface GetZobiDataRequest {
    id: number;
    personId: string;
}

export interface ListDistraintsRequest {
    personId: string;
    ordering?: string;
}

export interface ListPersonsRequest {
    birthNumber?: string;
    companyId?: string;
    excludedIds?: Array<number>;
    hasCompany?: boolean;
    hasDeal?: boolean;
    hasExecution?: boolean;
    hasInsolvency?: boolean;
    hasRole?: ListPersonsHasRoleEnum;
    id?: number;
    identification?: ListPersonsIdentificationEnum;
    isInternal?: boolean;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface ListRealtyRightsRequest {
    personId: string;
    ordering?: string;
}

export interface ListRelatedDealsRequest {
    personId: string;
    page?: number;
    pageSize?: number;
    state?: ListRelatedDealsStateEnum;
}

export interface ListScreeningsRequest {
    personId: string;
    dateFrom?: Date;
    dateTo?: Date;
    onlyLatest?: boolean;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    type?: ListScreeningsTypeEnum;
}

export interface PartialUpdateContactRequest {
    id: number;
    personId: string;
    patchedContactUpdate?: PatchedContactUpdate;
}

export interface PartialUpdateDistraintRequest {
    id: number;
    personId: string;
    patchedDistraint?: PatchedDistraint;
}

export interface PartialUpdatePersonRequest {
    id: number;
    patchedPerson?: PatchedPerson;
}

export interface RetrieveDistraintRequest {
    id: number;
    personId: string;
}

export interface RunScreeningRequest {
    personId: string;
    screening: Screening;
}

export interface UpdateAddressRequest {
    id: number;
    personId: string;
    addressUpdate?: AddressUpdate;
}

export interface UpdateContactRequest {
    id: number;
    personId: string;
    contactUpdate?: ContactUpdate;
}

export interface UpdatePersonRequest {
    id: number;
    person?: Person;
}

/**
 * PersonsApi - interface
 * 
 * @export
 * @interface PersonsApiInterface
 */
export interface PersonsApiInterface {
    /**
     * 
     * @param {string} personId 
     * @param {AddressCreate} addressCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    createAddressRaw(requestParameters: CreateAddressRequest): Promise<runtime.ApiResponse<AddressCreate>>;

    /**
     */
    createAddress(requestParameters: CreateAddressRequest): Promise<AddressCreate>;

    /**
     * 
     * @param {string} personId 
     * @param {Contact} contact 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    createContactRaw(requestParameters: CreateContactRequest): Promise<runtime.ApiResponse<Contact>>;

    /**
     */
    createContact(requestParameters: CreateContactRequest): Promise<Contact>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    createLeadRaw(requestParameters: CreateLeadRequest): Promise<runtime.ApiResponse<Lead>>;

    /**
     */
    createLead(requestParameters: CreateLeadRequest): Promise<Lead>;

    /**
     * 
     * @param {Person} [person] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    createPersonRaw(requestParameters: CreatePersonRequest): Promise<runtime.ApiResponse<Person>>;

    /**
     */
    createPerson(requestParameters: CreatePersonRequest): Promise<Person>;

    /**
     * 
     * @param {string} personId 
     * @param {CreateRelatedDeal} createRelatedDeal 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    createRelatedDealRaw(requestParameters: CreateRelatedDealRequest): Promise<runtime.ApiResponse<RelatedDeal>>;

    /**
     */
    createRelatedDeal(requestParameters: CreateRelatedDealRequest): Promise<RelatedDeal>;

    /**
     * 
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    downloadDistraintRaw(requestParameters: DownloadDistraintRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    downloadDistraint(requestParameters: DownloadDistraintRequest): Promise<void>;

    /**
     * 
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    downloadRealtyRightsRaw(requestParameters: DownloadRealtyRightsRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    downloadRealtyRights(requestParameters: DownloadRealtyRightsRequest): Promise<void>;

    /**
     * Endpoint generate transaction history export
     * @param {number} id A unique integer value identifying this screening.
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    downloadScreeningRaw(requestParameters: DownloadScreeningRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Endpoint generate transaction history export
     */
    downloadScreening(requestParameters: DownloadScreeningRequest): Promise<Blob>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base person.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    getPersonRaw(requestParameters: GetPersonRequest): Promise<runtime.ApiResponse<Person>>;

    /**
     */
    getPerson(requestParameters: GetPersonRequest): Promise<Person>;

    /**
     * 
     * @param {number} id A unique integer value identifying this screening.
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    getScreeningRaw(requestParameters: GetScreeningRequest): Promise<runtime.ApiResponse<Screening>>;

    /**
     */
    getScreening(requestParameters: GetScreeningRequest): Promise<Screening>;

    /**
     * 
     * @param {number} id A unique integer value identifying this screening.
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    getZobiDataRaw(requestParameters: GetZobiDataRequest): Promise<runtime.ApiResponse<ZobiScreeningData>>;

    /**
     */
    getZobiData(requestParameters: GetZobiDataRequest): Promise<ZobiScreeningData>;

    /**
     * 
     * @param {string} personId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    listDistraintsRaw(requestParameters: ListDistraintsRequest): Promise<runtime.ApiResponse<Array<Distraint>>>;

    /**
     */
    listDistraints(requestParameters: ListDistraintsRequest): Promise<Array<Distraint>>;

    /**
     * 
     * @param {string} [birthNumber] 
     * @param {string} [companyId] 
     * @param {Array<number>} [excludedIds] Více hodnot lze oddělit čárkami.
     * @param {boolean} [hasCompany] 
     * @param {boolean} [hasDeal] 
     * @param {boolean} [hasExecution] 
     * @param {boolean} [hasInsolvency] 
     * @param {'ACCESSORY_DEBTOR' | 'BORROWER' | 'BUYER' | 'CREDITOR' | 'DEBTOR' | 'FUTURE_BUYER' | 'FUTURE_SELLER' | 'LANDLORD' | 'LENDER' | 'MEDIATOR' | 'MORTGAGOR' | 'PLEDGER' | 'SELLER' | 'SUBTENANT' | 'TENANT'} [hasRole] 
     * @param {number} [id] 
     * @param {'BIRTH_NUMBER' | 'ICO'} [identification] 
     * @param {boolean} [isInternal] if is_internal is true, operation returns internal persons, if is internal is false operation returns only non internal persons. If is_internal is not set operation returns all persons.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    listPersonsRaw(requestParameters: ListPersonsRequest): Promise<runtime.ApiResponse<PaginatedPersonList>>;

    /**
     */
    listPersons(requestParameters: ListPersonsRequest): Promise<PaginatedPersonList>;

    /**
     * 
     * @param {string} personId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    listRealtyRightsRaw(requestParameters: ListRealtyRightsRequest): Promise<runtime.ApiResponse<Array<RealtyRight>>>;

    /**
     */
    listRealtyRights(requestParameters: ListRealtyRightsRequest): Promise<Array<RealtyRight>>;

    /**
     * 
     * @param {string} personId 
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {'ACTIVE' | 'CLOSED' | 'CLOSED_APPLICATION' | 'CONTRACT_COMPLETION' | 'CONTRACT_SIGN' | 'FILED_FOR_INSOLVENCY' | 'NEW_APPLICATION'} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    listRelatedDealsRaw(requestParameters: ListRelatedDealsRequest): Promise<runtime.ApiResponse<PaginatedRelatedDealsList>>;

    /**
     */
    listRelatedDeals(requestParameters: ListRelatedDealsRequest): Promise<PaginatedRelatedDealsList>;

    /**
     * 
     * @param {string} personId 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {boolean} [onlyLatest] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] 
     * @param {'ISIR_INSOLVENCY' | 'ISPIS_CEE' | 'ISPIS_OBCHR' | 'ISPIS_OSOBACUZK' | 'ISPIS_RZP' | 'MVCR_IDENTITY_CARD' | 'TRANSACTION_SCORING' | 'ZOBI_OSOBACUZK'} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    listScreeningsRaw(requestParameters: ListScreeningsRequest): Promise<runtime.ApiResponse<PaginatedScreeningListItemList>>;

    /**
     */
    listScreenings(requestParameters: ListScreeningsRequest): Promise<PaginatedScreeningListItemList>;

    /**
     * 
     * @param {number} id A unique integer value identifying this contact.
     * @param {string} personId 
     * @param {PatchedContactUpdate} [patchedContactUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    partialUpdateContactRaw(requestParameters: PartialUpdateContactRequest): Promise<runtime.ApiResponse<ContactUpdate>>;

    /**
     */
    partialUpdateContact(requestParameters: PartialUpdateContactRequest): Promise<ContactUpdate>;

    /**
     * 
     * @param {number} id A unique integer value identifying this distraint.
     * @param {string} personId 
     * @param {PatchedDistraint} [patchedDistraint] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    partialUpdateDistraintRaw(requestParameters: PartialUpdateDistraintRequest): Promise<runtime.ApiResponse<Distraint>>;

    /**
     */
    partialUpdateDistraint(requestParameters: PartialUpdateDistraintRequest): Promise<Distraint>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base person.
     * @param {PatchedPerson} [patchedPerson] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    partialUpdatePersonRaw(requestParameters: PartialUpdatePersonRequest): Promise<runtime.ApiResponse<Person>>;

    /**
     */
    partialUpdatePerson(requestParameters: PartialUpdatePersonRequest): Promise<Person>;

    /**
     * 
     * @param {number} id A unique integer value identifying this distraint.
     * @param {string} personId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    retrieveDistraintRaw(requestParameters: RetrieveDistraintRequest): Promise<runtime.ApiResponse<Distraint>>;

    /**
     */
    retrieveDistraint(requestParameters: RetrieveDistraintRequest): Promise<Distraint>;

    /**
     * 
     * @param {string} personId 
     * @param {Screening} screening 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    runScreeningRaw(requestParameters: RunScreeningRequest): Promise<runtime.ApiResponse<Screening>>;

    /**
     */
    runScreening(requestParameters: RunScreeningRequest): Promise<Screening>;

    /**
     * 
     * @param {number} id A unique integer value identifying this address.
     * @param {string} personId 
     * @param {AddressUpdate} [addressUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    updateAddressRaw(requestParameters: UpdateAddressRequest): Promise<runtime.ApiResponse<AddressUpdate>>;

    /**
     */
    updateAddress(requestParameters: UpdateAddressRequest): Promise<AddressUpdate>;

    /**
     * 
     * @param {number} id A unique integer value identifying this contact.
     * @param {string} personId 
     * @param {ContactUpdate} [contactUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    updateContactRaw(requestParameters: UpdateContactRequest): Promise<runtime.ApiResponse<ContactUpdate>>;

    /**
     */
    updateContact(requestParameters: UpdateContactRequest): Promise<ContactUpdate>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base person.
     * @param {Person} [person] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonsApiInterface
     */
    updatePersonRaw(requestParameters: UpdatePersonRequest): Promise<runtime.ApiResponse<Person>>;

    /**
     */
    updatePerson(requestParameters: UpdatePersonRequest): Promise<Person>;

}

/**
 * 
 */
export class PersonsApi extends runtime.BaseAPI implements PersonsApiInterface {

    /**
     */
    async createAddressRaw(requestParameters: CreateAddressRequest): Promise<runtime.ApiResponse<AddressCreate>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling createAddress.');
        }

        if (requestParameters.addressCreate === null || requestParameters.addressCreate === undefined) {
            throw new runtime.RequiredError('addressCreate','Required parameter requestParameters.addressCreate was null or undefined when calling createAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/address/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddressCreateToJSON(requestParameters.addressCreate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressCreateFromJSON(jsonValue));
    }

    /**
     */
    async createAddress(requestParameters: CreateAddressRequest): Promise<AddressCreate> {
        const response = await this.createAddressRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createContactRaw(requestParameters: CreateContactRequest): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling createContact.');
        }

        if (requestParameters.contact === null || requestParameters.contact === undefined) {
            throw new runtime.RequiredError('contact','Required parameter requestParameters.contact was null or undefined when calling createContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/contact/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactToJSON(requestParameters.contact),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     */
    async createContact(requestParameters: CreateContactRequest): Promise<Contact> {
        const response = await this.createContactRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createLeadRaw(requestParameters: CreateLeadRequest): Promise<runtime.ApiResponse<Lead>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{id}/lead/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LeadFromJSON(jsonValue));
    }

    /**
     */
    async createLead(requestParameters: CreateLeadRequest): Promise<Lead> {
        const response = await this.createLeadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createPersonRaw(requestParameters: CreatePersonRequest): Promise<runtime.ApiResponse<Person>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PersonToJSON(requestParameters.person),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async createPerson(requestParameters: CreatePersonRequest): Promise<Person> {
        const response = await this.createPersonRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createRelatedDealRaw(requestParameters: CreateRelatedDealRequest): Promise<runtime.ApiResponse<RelatedDeal>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling createRelatedDeal.');
        }

        if (requestParameters.createRelatedDeal === null || requestParameters.createRelatedDeal === undefined) {
            throw new runtime.RequiredError('createRelatedDeal','Required parameter requestParameters.createRelatedDeal was null or undefined when calling createRelatedDeal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/deals/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRelatedDealToJSON(requestParameters.createRelatedDeal),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedDealFromJSON(jsonValue));
    }

    /**
     */
    async createRelatedDeal(requestParameters: CreateRelatedDealRequest): Promise<RelatedDeal> {
        const response = await this.createRelatedDealRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async downloadDistraintRaw(requestParameters: DownloadDistraintRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling downloadDistraint.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/distraint/download/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async downloadDistraint(requestParameters: DownloadDistraintRequest): Promise<void> {
        await this.downloadDistraintRaw(requestParameters);
    }

    /**
     */
    async downloadRealtyRightsRaw(requestParameters: DownloadRealtyRightsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling downloadRealtyRights.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/realty-rights/download/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async downloadRealtyRights(requestParameters: DownloadRealtyRightsRequest): Promise<void> {
        await this.downloadRealtyRightsRaw(requestParameters);
    }

    /**
     * Endpoint generate transaction history export
     */
    async downloadScreeningRaw(requestParameters: DownloadScreeningRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling downloadScreening.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling downloadScreening.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/screenings/{id}/download/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Endpoint generate transaction history export
     */
    async downloadScreening(requestParameters: DownloadScreeningRequest): Promise<Blob> {
        const response = await this.downloadScreeningRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getPersonRaw(requestParameters: GetPersonRequest): Promise<runtime.ApiResponse<Person>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async getPerson(requestParameters: GetPersonRequest): Promise<Person> {
        const response = await this.getPersonRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getScreeningRaw(requestParameters: GetScreeningRequest): Promise<runtime.ApiResponse<Screening>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getScreening.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getScreening.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/screenings/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ScreeningFromJSON(jsonValue));
    }

    /**
     */
    async getScreening(requestParameters: GetScreeningRequest): Promise<Screening> {
        const response = await this.getScreeningRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getZobiDataRaw(requestParameters: GetZobiDataRequest): Promise<runtime.ApiResponse<ZobiScreeningData>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getZobiData.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getZobiData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/screenings/{id}/zobi/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ZobiScreeningDataFromJSON(jsonValue));
    }

    /**
     */
    async getZobiData(requestParameters: GetZobiDataRequest): Promise<ZobiScreeningData> {
        const response = await this.getZobiDataRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDistraintsRaw(requestParameters: ListDistraintsRequest): Promise<runtime.ApiResponse<Array<Distraint>>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling listDistraints.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/distraint/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DistraintFromJSON));
    }

    /**
     */
    async listDistraints(requestParameters: ListDistraintsRequest): Promise<Array<Distraint>> {
        const response = await this.listDistraintsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listPersonsRaw(requestParameters: ListPersonsRequest): Promise<runtime.ApiResponse<PaginatedPersonList>> {
        const queryParameters: any = {};

        if (requestParameters.birthNumber !== undefined) {
            queryParameters['birth_number'] = requestParameters.birthNumber;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['company_id'] = requestParameters.companyId;
        }

        if (requestParameters.excludedIds) {
            queryParameters['excluded_ids'] = requestParameters.excludedIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.hasCompany !== undefined) {
            queryParameters['has_company'] = requestParameters.hasCompany;
        }

        if (requestParameters.hasDeal !== undefined) {
            queryParameters['has_deal'] = requestParameters.hasDeal;
        }

        if (requestParameters.hasExecution !== undefined) {
            queryParameters['has_execution'] = requestParameters.hasExecution;
        }

        if (requestParameters.hasInsolvency !== undefined) {
            queryParameters['has_insolvency'] = requestParameters.hasInsolvency;
        }

        if (requestParameters.hasRole !== undefined) {
            queryParameters['has_role'] = requestParameters.hasRole;
        }

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.identification !== undefined) {
            queryParameters['identification'] = requestParameters.identification;
        }

        if (requestParameters.isInternal !== undefined) {
            queryParameters['is_internal'] = requestParameters.isInternal;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPersonListFromJSON(jsonValue));
    }

    /**
     */
    async listPersons(requestParameters: ListPersonsRequest): Promise<PaginatedPersonList> {
        const response = await this.listPersonsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listRealtyRightsRaw(requestParameters: ListRealtyRightsRequest): Promise<runtime.ApiResponse<Array<RealtyRight>>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling listRealtyRights.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/realty-rights/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RealtyRightFromJSON));
    }

    /**
     */
    async listRealtyRights(requestParameters: ListRealtyRightsRequest): Promise<Array<RealtyRight>> {
        const response = await this.listRealtyRightsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listRelatedDealsRaw(requestParameters: ListRelatedDealsRequest): Promise<runtime.ApiResponse<PaginatedRelatedDealsList>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling listRelatedDeals.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/deals/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedRelatedDealsListFromJSON(jsonValue));
    }

    /**
     */
    async listRelatedDeals(requestParameters: ListRelatedDealsRequest): Promise<PaginatedRelatedDealsList> {
        const response = await this.listRelatedDealsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listScreeningsRaw(requestParameters: ListScreeningsRequest): Promise<runtime.ApiResponse<PaginatedScreeningListItemList>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling listScreenings.');
        }

        const queryParameters: any = {};

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['date_from'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.onlyLatest !== undefined) {
            queryParameters['only_latest'] = requestParameters.onlyLatest;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/screenings/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedScreeningListItemListFromJSON(jsonValue));
    }

    /**
     */
    async listScreenings(requestParameters: ListScreeningsRequest): Promise<PaginatedScreeningListItemList> {
        const response = await this.listScreeningsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateContactRaw(requestParameters: PartialUpdateContactRequest): Promise<runtime.ApiResponse<ContactUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateContact.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling partialUpdateContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/contact/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedContactUpdateToJSON(requestParameters.patchedContactUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactUpdateFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateContact(requestParameters: PartialUpdateContactRequest): Promise<ContactUpdate> {
        const response = await this.partialUpdateContactRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateDistraintRaw(requestParameters: PartialUpdateDistraintRequest): Promise<runtime.ApiResponse<Distraint>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateDistraint.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling partialUpdateDistraint.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/distraint/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDistraintToJSON(requestParameters.patchedDistraint),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DistraintFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateDistraint(requestParameters: PartialUpdateDistraintRequest): Promise<Distraint> {
        const response = await this.partialUpdateDistraintRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdatePersonRaw(requestParameters: PartialUpdatePersonRequest): Promise<runtime.ApiResponse<Person>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdatePerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPersonToJSON(requestParameters.patchedPerson),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdatePerson(requestParameters: PartialUpdatePersonRequest): Promise<Person> {
        const response = await this.partialUpdatePersonRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async retrieveDistraintRaw(requestParameters: RetrieveDistraintRequest): Promise<runtime.ApiResponse<Distraint>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling retrieveDistraint.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling retrieveDistraint.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/distraint/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DistraintFromJSON(jsonValue));
    }

    /**
     */
    async retrieveDistraint(requestParameters: RetrieveDistraintRequest): Promise<Distraint> {
        const response = await this.retrieveDistraintRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async runScreeningRaw(requestParameters: RunScreeningRequest): Promise<runtime.ApiResponse<Screening>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling runScreening.');
        }

        if (requestParameters.screening === null || requestParameters.screening === undefined) {
            throw new runtime.RequiredError('screening','Required parameter requestParameters.screening was null or undefined when calling runScreening.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/screenings/`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScreeningToJSON(requestParameters.screening),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ScreeningFromJSON(jsonValue));
    }

    /**
     */
    async runScreening(requestParameters: RunScreeningRequest): Promise<Screening> {
        const response = await this.runScreeningRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateAddressRaw(requestParameters: UpdateAddressRequest): Promise<runtime.ApiResponse<AddressUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateAddress.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling updateAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/address/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddressUpdateToJSON(requestParameters.addressUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressUpdateFromJSON(jsonValue));
    }

    /**
     */
    async updateAddress(requestParameters: UpdateAddressRequest): Promise<AddressUpdate> {
        const response = await this.updateAddressRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateContactRaw(requestParameters: UpdateContactRequest): Promise<runtime.ApiResponse<ContactUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateContact.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling updateContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{personId}/contact/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ContactUpdateToJSON(requestParameters.contactUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactUpdateFromJSON(jsonValue));
    }

    /**
     */
    async updateContact(requestParameters: UpdateContactRequest): Promise<ContactUpdate> {
        const response = await this.updateContactRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updatePersonRaw(requestParameters: UpdatePersonRequest): Promise<runtime.ApiResponse<Person>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/persons/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PersonToJSON(requestParameters.person),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async updatePerson(requestParameters: UpdatePersonRequest): Promise<Person> {
        const response = await this.updatePersonRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListPersonsHasRoleEnum {
    AccessoryDebtor = 'ACCESSORY_DEBTOR',
    Borrower = 'BORROWER',
    Buyer = 'BUYER',
    Creditor = 'CREDITOR',
    Debtor = 'DEBTOR',
    FutureBuyer = 'FUTURE_BUYER',
    FutureSeller = 'FUTURE_SELLER',
    Landlord = 'LANDLORD',
    Lender = 'LENDER',
    Mediator = 'MEDIATOR',
    Mortgagor = 'MORTGAGOR',
    Pledger = 'PLEDGER',
    Seller = 'SELLER',
    Subtenant = 'SUBTENANT',
    Tenant = 'TENANT'
}
/**
    * @export
    * @enum {string}
    */
export enum ListPersonsIdentificationEnum {
    BirthNumber = 'BIRTH_NUMBER',
    Ico = 'ICO'
}
/**
    * @export
    * @enum {string}
    */
export enum ListRelatedDealsStateEnum {
    Active = 'ACTIVE',
    Closed = 'CLOSED',
    ClosedApplication = 'CLOSED_APPLICATION',
    ContractCompletion = 'CONTRACT_COMPLETION',
    ContractSign = 'CONTRACT_SIGN',
    FiledForInsolvency = 'FILED_FOR_INSOLVENCY',
    NewApplication = 'NEW_APPLICATION'
}
/**
    * @export
    * @enum {string}
    */
export enum ListScreeningsTypeEnum {
    IsirInsolvency = 'ISIR_INSOLVENCY',
    IspisCee = 'ISPIS_CEE',
    IspisObchr = 'ISPIS_OBCHR',
    IspisOsobacuzk = 'ISPIS_OSOBACUZK',
    IspisRzp = 'ISPIS_RZP',
    MvcrIdentityCard = 'MVCR_IDENTITY_CARD',
    TransactionScoring = 'TRANSACTION_SCORING',
    ZobiOsobacuzk = 'ZOBI_OSOBACUZK'
}
